import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FastRewindIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fast_rewind"}/>
}
